import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button } from '@dsny/dsny-component-library'
import { Close } from '@dsny/dsny-component-library/icons'
import { placeholderLogo } from 'images'
import { trackEvent } from 'utils/segmentService'
import {
  RELEASE_COVER_ART_MODAL_BODY_STYLES,
  RELEASE_COVER_ART_MODAL_CONTAINER_STYLES,
  ModalBody,
  CloseButtonWrapper,
  CoverArtImage
} from './ReleaseCoverArtModal.styles'

type ReleaseCoverArtModalProps = {
  coverArt?: string
  isOpen?: boolean
  onClose: (event?: React.SyntheticEvent) => void
}

export default function ReleaseCoverArtModal({
  coverArt = '',
  isOpen = false,
  onClose
}: ReleaseCoverArtModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      analyticsModalType="release_cover_art"
      bodyStyles={RELEASE_COVER_ART_MODAL_BODY_STYLES}
      containerStyles={RELEASE_COVER_ART_MODAL_CONTAINER_STYLES}
      isOpen={isOpen}
      trackEvent={trackEvent}
      onClose={onClose}>
      <ModalBody className="shadow-dark" onClick={onClose}>
        <CloseButtonWrapper onClick={(event) => event.stopPropagation()}>
          <Button
            aria-label={t('release-info.close-cover-art')}
            setting="player"
            variant="icon-dark"
            onClick={onClose}>
            <Close height={24} width={24} />
          </Button>
        </CloseButtonWrapper>
        <CoverArtImage
          alt={t('release-info.cover-art-alt')}
          fallback={placeholderLogo}
          src={coverArt}
          onClick={(event) => event.stopPropagation()} />
      </ModalBody>
    </Modal>
  )
}
